"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _getComponent = _interopRequireDefault(require("./getComponent"));
var addCss = function addCss(baseUrl) {
  var style = document.createElement('link');
  style.rel = 'stylesheet';
  style.href = "".concat(baseUrl, ".css");
  document.head.appendChild(style);
};
var addJs = function addJs(baseUrl, cb) {
  var script = document.createElement('script');
  script.src = "".concat(baseUrl, ".js");
  script.type = 'text/javascript';
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.onload = cb;
  document.head.appendChild(script);
};
var _default = exports.default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(props, cdnProps) {
    var hasBundledCss, namespace, cdnUrl, isLocal, version, filename, baseUrl;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(0, _getComponent.default)(props)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          hasBundledCss = props.hasBundledCss, namespace = props.namespace;
          cdnUrl = cdnProps.cdnUrl, isLocal = cdnProps.isLocal, version = cdnProps.version;
          filename = isLocal ? namespace : "".concat(namespace).concat(version ? "-".concat(version) : '');
          baseUrl = "".concat(cdnUrl, "/").concat(filename);
          if (hasBundledCss) addCss(baseUrl);
          _context.next = 9;
          return new Promise(function (resolve) {
            addJs(baseUrl, resolve);
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();